import axios from "axios";
import Loading from "../../components/common/loading/loading";
import BASE_URL from "../../constants/baseUrls";
import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LocaleContext } from "../../routing/LangRouter";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export function QRCode(params) {
    const accessToken = localStorage.getItem("accessToken");
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    const redirect = async () => {
        const id = searchParams.get("pk");
        try {
            const response = await axios.get(`${BASE_URL}/qr-code/redirect/${id}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            const domain = window.location.hostname;
            const data = response.data.data;
            if (domain === data.scheme_netloc) {
                navigate(`/${data.path}`);
            } else {
                window.location.replace(data.scheme_netloc + data.path, "_blank");
            }
        } catch (error) {
            toast.error(t("errorMessage"), { toastId: "custom-id-yes" });
        }
    };
    useEffect(() => {
        redirect();
    }, []);
    return <Loading />;
}
